export enum InvoiceStatus {
  New = 'new',
  Pending = 'pending',
  Confirmed = 'confirmed',
  PendingCredit = 'pending_credit',
  ConfirmedCredit = 'confirmed_credit'
}
